import Link, { LinkProps } from 'next/link'

import { PopoverControlButton } from '@audio-network/componentlibrary'
import { SidebarNavItemProps } from './SidebarNavItem.types'
import clsx from 'clsx'
import sidebarStyles from '../Sidebar.module.css'
import styles from './SidebarNavItem.module.css'

const SidebarNavItem = ({
	startIcon,
	content,
	href,
	onClick,
	popovertarget,
	...props
}: SidebarNavItemProps): JSX.Element => {
	const children = (
		<>
			<span
				className={clsx(styles.hoverState, sidebarStyles.showWhenExpanded)}
			></span>
			<span className={styles.icon}>{startIcon}</span>
			<span className={clsx(styles.content, sidebarStyles.showWhenExpanded)}>
				{content}
			</span>
		</>
	)

	return (
		<li>
			{popovertarget ? (
				<PopoverControlButton
					className={styles.navItem}
					onClick={onClick}
					popovertarget={popovertarget}
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					{...(props as any)}
				>
					{children}
				</PopoverControlButton>
			) : (
				<Link
					className={styles.navItem}
					onClick={onClick}
					href={href}
					{...(props as unknown as LinkProps)}
					locale={false}
				>
					{children}
				</Link>
			)}
		</li>
	)
}

export default SidebarNavItem
